let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jj97c")).then(() => parcelRequire('5hnEv'));